import React from 'react';

/**
 * PanelTypeMenuItem - Tek bir çıkış butonu
 * @param {{ outputType: object, onAdd: function }} props
 */
export default function PanelTypeMenuItem({ outputType, onAdd }) {
  return (
    <button
      onClick={() => onAdd(outputType)}
      className="my-button"
      style={{ textAlign: 'left', fontSize: '13px' }}
    >
      {outputType.label} Ekle
    </button>
  );
}
